import { memo } from "react";
import MaxWidthLayout from "./MaxWidthLayout";

const Video = () => {
  return (
    <MaxWidthLayout>
      <div className="m-auto w-90% md:w-80% border border-black border-solid rounded-21px flex flex-col items-center justify-center bg-white mt-64px md:mt-112px pb-24px md:pb-64px">
        <h2 className="text-green-1 font-semibold text-26px md:text-4xl pt-24px pb-16px md:pt-36px md:pb-24px">
          宣傳影片
        </h2>
        <div className="relative w-90% pb-50%">
          <iframe
            className="absolute top-0 left-0 w-full h-full "
            // src="https://www.youtube.com/embed/XdQWQ64LPAo"
            src="https://www.youtube.com/embed/nYgSoCUzOBU"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </MaxWidthLayout>
  );
};
export default memo(Video);
